import { z } from 'zod'
import { isoDate } from '../previsions-produits/-search-schema'

export const yesterday = (): string => {
  const date = new Date()
  date.setDate(date.getDate() - 1)
  return isoDate(date)
}

export const controleRuptureSearchSchema = z.object({
  storeIds: z.array(z.number()).default([]),
  date: z.string().optional(),
})

export type ControleRuptureSearch = z.infer<typeof controleRuptureSearchSchema>
